import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { ExternalIntegration } from "types/generated";

const ServiceNowTableSpaceCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={integration.spaceDetails.id}
        fallbackName={integration.spaceDetails.name}
      />
    </TableSimpleCell>
  );
};

export default ServiceNowTableSpaceCell;
